import { AuthorizationUpdated } from "event-definitions"
import { isEnabled } from "lib/@components/feature"
import { noChange } from "lib/@hooks/useRefresh"
import { hasDemand } from "lib/authorization/has-demand"
import { getCurrentClientId, useClientInfo } from "minimals-template/components/contexts/NognitoContext"
import { useTreeItemIndex } from "routes/schedule/lib/useTreeItemIndex"
import { REGIME_SCHEDULE_COUNTS_FEATURE } from "./regime-schedule-counts-constants.mjs"
import { getSelectedRegimeScheduleTotal } from "./selected-regime-schedule-total"

export function useRegimeScheduleTotal(item, selectedId, { fromIndex = false, state } = {}) {
    useClientInfo()
    const index = useTreeItemIndex()
    if (fromIndex) item = typeof selectedId === "string" ? index?.retrieve?.(selectedId) : undefined
    AuthorizationUpdated.useRefresh(noChange)
    return readRegimeScheduleTotal(item, selectedId, state)
}

// Not a hook, so the regime table can also call it when sorting.
export function readRegimeScheduleTotal(item, selectedId, state) {
    return getSelectedRegimeScheduleTotal({
        item,
        selectedId,
        state,
        currentClient: getCurrentClientId(),
        enabled: isEnabled(REGIME_SCHEDULE_COUNTS_FEATURE),
        sharing: hasDemand("$sharing"),
    })
}
